import toast from 'react-hot-toast';

import {
  ErrorResponse,
  FacebookConnection,
  FacebookConnectionService,
  FBLoginResponse,
} from 'us-web-services';
import { UserStore } from '../models';

export class FacebookUtil {
  static linkFacebook(
    facebookResponse: FBLoginResponse,
    userStore: UserStore,
    t: (message: string) => string,
    callback?: () => void,
  ): void {
    if (facebookResponse.authResponse) {
      const facebookConnection: FacebookConnection = {
        userId: userStore.user.id,
        facebookUser: {
          id: userStore.user.id,
          facebookId: facebookResponse.authResponse.userID,
          accessToken: facebookResponse.authResponse.accessToken,
        },
      };

      void (async (): Promise<void> => {
        try {
          await FacebookConnectionService.create(facebookConnection);
          toast.success(t('notifications.facebook.success'), { icon: '🎉' });
          userStore.refreshUser();
          if (callback) {
            callback();
          }
        } catch (errorResponse) {
          const er = errorResponse as ErrorResponse;
          if (er.errors) {
            toast.error(er.errors[0].message);
          } else {
            toast.error(t('notifications.facebook.error'));
          }
        }
      })();
    } else {
      toast.error(t('notifications.facebook.error'));
    }
  }
}
